import { combineReducers, configureStore } from '@reduxjs/toolkit';
import * as Sentry from '@sentry/react';
import errorHandlerMiddleware from 'middlewares/errorHandlerMiddleware';
import saveApplicationDataMiddleware from 'middlewares/saveApplicationDataMiddleware';
import { SessionStorageField } from 'types';
import { getSessionStorageItem } from 'utils/getSessionStorageItem';
import application from './application';
import loading from './loading';

const rootReducer = combineReducers({
  loading,
  application,
});

export type PreloadedStateType = ReturnType<typeof rootReducer>;

const initialStateFromSessionStorage = getSessionStorageItem(SessionStorageField.AppState);

const initialState: PreloadedStateType | undefined = initialStateFromSessionStorage
  ? (JSON.parse(initialStateFromSessionStorage) as PreloadedStateType)
  : undefined;

export const store = configureStore({
  reducer: rootReducer,
  preloadedState: initialState,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(errorHandlerMiddleware, saveApplicationDataMiddleware),
  enhancers: [Sentry.createReduxEnhancer({})],
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
